/**
 * Created by glenn on 7/25/2017.
 */
import 'webmapsjs/dist/import-queryui';

import React = require("react");
import ReactDom = require("react-dom");
import {connect, Provider} from 'react-redux';
import {store, setMap, iState, setRoads, setLayers, setData} from './store';
import * as apiActions from '../../api/npmrds/actions';
import {WaitingIndicator} from '../../api/npmrds/components/connected';
import * as heatMapActions from './actions';
import {DateRangeConnected, VersionLabel} from '../../api/npmrds/components/connected';
import quickMap from 'webmapsjs/dist/olHelpers/quickMap';
import {LayerEsriTile} from 'webmapsjs/dist/layers/LayerEsriTile';
import LayerEsriMapServer from 'webmapsjs/dist/layers/LayerEsriMapServer';
import LayerBaseVectorGeoJson from 'webmapsjs/dist/layers/LayerBaseVectorGeoJson';
import * as layerStyles from './layerStyles';
import {proj3857, proj4326} from 'webmapsjs/dist/olHelpers/projections';
import {SelectArea} from 'webmapsjs/dist/reactComponents/SelectArea';
import {getRoads, getRoute} from 'webmapsjs/dist/api/npmrds';
import {RadioHighway} from './RadioHwy';
import {HeatMap} from './heatmap'
import {Generate} from './generate';
import {V2switcher} from './v2switcher';

function updateRoads() {

    setData();




    let ste = store.getState() as iState;
    let ext = ste.extent;

    let v = 1;

    let breakDate = new Date('01/31/2017');

    if (ste.startEndDate.end > breakDate) {
        v = ste.startEndDate.end.getFullYear();
    }


    if (ext.coordinates.length > 0) {
        store.dispatch({type: heatMapActions.ACTION_SET_WAITING, waiting: true});
        getRoads(ste.extent, v, (d) => {
            setRoads(d.roads);
            store.dispatch({type: heatMapActions.ACTION_SET_WAITING, waiting: false});
        });
    } else {
        setRoads([]);
    }
}

class App extends React.Component<{}, {}> {

    constructor(p, c) {
        super(p, c);
    }

    componentDidMount() {
        let map = quickMap({center: {x: -10012438, y: 5548095}, zoom: 8, minZoom: 5});

        setMap(map);

        let xyzTile = new LayerEsriTile(
            'https://transportal.cee.wisc.edu/applications/arcgis2/rest/services/NPMRDS/npmrds_tile/MapServer',
            {minZoom: 4, maxZoom: 11}
        );

        let esriMapServer = new LayerEsriMapServer(
            'https://transportal.cee.wisc.edu/applications/arcgis2/rest/services/NPMRDS/npmrds_dynamic/MapServer',
            {minZoom: 12, maxZoom: 18}
        );

        map.addLayer(xyzTile.olLayer);
        map.addLayer(esriMapServer.olLayer);

        let transform = {dataProjection: proj4326, featureProjection: proj3857};

        let lineLayer = new LayerBaseVectorGeoJson('', {
            style: layerStyles.lineIndicator,
            transform: transform
        });

        let pointLayer = new LayerBaseVectorGeoJson('', {
            style: layerStyles.pointIndices,
            transform: transform
        });

        let trackerLayer = new LayerBaseVectorGeoJson('', {
            style: layerStyles.trackerPoint,
            transform: transform
        });

        setLayers(lineLayer, pointLayer, trackerLayer);

        map.addLayer(lineLayer.olLayer);
        map.addLayer(trackerLayer.olLayer);
    }

    render() {
        return <div id="container">
            <div id="map">
                <div id="controls">
                    <SelectArea
                        map={() => {
                            return (store.getState() as iState).map;
                        }}
                        callback={(coords: Array<number[]>) => {
                            store.dispatch({type: apiActions.ACTION_COORDINATES, coords: coords});
                            updateRoads();
                        }}
                    />
                    <DateRangeConnected/>
                    <VersionLabel/>
                    {/*<V2switcher/>*/}
                    <WaitingIndicator/>
                    <RadioHighway/>
                    <Generate/>
                </div>
            </div>
            <HeatMap/>
        </div>
    }
}

let ste_ = store.getState() as iState;
let ver = ste_.startEndDate.version;
let startEnd = ste_.startEndDate;
let endYear = undefined;

store.subscribe(() => {
    let ste = store.getState() as iState;
    console.log(ste);

    let yr = undefined;

    if (ste.startEndDate.end){
        yr = ste.startEndDate.end.getFullYear()
    }


    if (ste.startEndDate.version !== ver || yr !== endYear) {
        ver = ste.startEndDate.version;
        endYear = yr;

        if (ste.extent.set) {
            updateRoads();
        }
    }

    if (startEnd !== ste.startEndDate) {
        startEnd = ste.startEndDate;
        setData();
    }
});

ReactDom.render(<Provider store={store}><App/></Provider>, document.getElementById('app'));

// declare const glob;


// console.log('setting');
// setData(glob.testData);

// store.dispatch({type: ACTION_SET_DATA, data: glob.testData as iRoute});




